var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopPerson = function SvgStopPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M17 10c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7m-5 7c0-2.8 2.2-5 5-5 1 0 2 .3 2.8.8l-6.9 6.9C12.3 19 12 18 12 17m5 5c-1 0-2-.3-2.8-.8l6.9-6.9c.5.8.8 1.7.8 2.8.1 2.7-2.1 4.9-4.9 4.9M4 4.5C4 7 6 9 8.5 9S13 7 13 4.5 11 0 8.5 0 4 2 4 4.5m7 0C11 5.9 9.9 7 8.5 7S6 5.9 6 4.5 7.1 2 8.5 2 11 3.1 11 4.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M2 16v-1c0-1.7 1.3-3 3-3h5.8c.6-.8 1.4-1.4 2.2-1.9-.3-.1-.6-.1-1-.1H5c-2.8 0-5 2.2-5 5v3h9.1c0-.3-.1-.7-.1-1s0-.7.1-1z"
  })));
};
export default SvgStopPerson;